import { useLanguage } from '@/i18n/LanguageContext';
import { motion } from 'framer-motion';

const AboutSection = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="relative py-24 md:py-32">
      <div className="container mx-auto px-6">
        <div className="grid items-center gap-12 md:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}>

            <div className="relative overflow-hidden rounded-lg">
              <img
                src="https://images.unsplash.com/photo-1529260830199-42c24126f198?w=800&q=75&fm=webp"
                alt="Luxury interior Rome"
                className="h-[500px] w-full object-cover"
                loading="lazy" />

              <div className="absolute inset-0 gold-border rounded-lg" />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}>

            <p className="font-serif-elegant uppercase tracking-[0.3em] text-primary/70 text-base font-bold">
              Our Story
            </p>
            <h2 className="mt-3 font-serif text-3xl tracking-wide text-foreground md:text-4xl">
              {t.about.title}
            </h2>
            <p className="mt-2 font-serif-elegant text-lg italic text-champagne/70 font-bold">
              {t.about.subtitle}
            </p>
            <p className="mt-6 font-sans text-sm leading-relaxed text-muted-foreground">
              {t.about.p1}
            </p>
            <p className="mt-4 font-sans text-sm leading-relaxed text-muted-foreground">
              {t.about.p2}
            </p>
            <div className="mt-8 flex gap-12">
              <div>
                <p className="font-serif text-3xl text-primary">4</p>
                <p className="mt-1 text-xs uppercase tracking-widest text-muted-foreground">Apartments</p>
              </div>
              <div>
                <p className="font-serif text-3xl text-primary">190+</p>
                <p className="mt-1 text-xs uppercase tracking-widest text-muted-foreground">Reviews</p>
              </div>
              <div>
                <p className="font-serif text-3xl text-primary">4.8★</p>
                <p className="mt-1 text-xs uppercase tracking-widest text-muted-foreground">Average</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>);

};

export default AboutSection;